export const DefaultActiveSlideSelector = "is-active";
